import script from "./CourseReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseReviews.vue?vue&type=script&setup=true&lang=js"

import "./CourseReviews.vue?vue&type=style&index=0&id=43c8d704&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c8d704"]])

export default __exports__